module.exports = __webpack_public_path__ + "assets/img/2多账号.2d0663bb.png";